export function useWhiteboardShapeActions({ setShapes, setSelectedShape, setPdfModal }) {
  const handlePdfModalClose = () => setPdfModal(null);

  const handleShapeChange = (updatedShape) => {
    setShapes(prev => prev.map(s => s.id === updatedShape.id ? updatedShape : s));
  };

  const handleShapeDuplicate = (shape) => {
    const duplicatedShape = {
      ...shape,
      id: Date.now() + Math.random(),
      x: shape.x + 20,
      y: shape.y + 20,
    };
    setShapes(prev => [...prev, duplicatedShape]);
  };

  const handleShapeDelete = (shapeId) => {
    setShapes(prev => prev.filter(s => s.id !== shapeId));
    setSelectedShape(null);
  };

  const handleShapeBringForward = (shapeId) => {
    setShapes(prev => {
      const idx = prev.findIndex(s => s.id === shapeId);
      if (idx === -1 || idx === prev.length - 1) return prev;
      const next = [...prev];
      const [shape] = next.splice(idx, 1);
      next.splice(idx + 1, 0, shape);
      return next;
    });
  };

  const handleShapeSendBackward = (shapeId) => {
    setShapes(prev => {
      const idx = prev.findIndex(s => s.id === shapeId);
      if (idx <= 0) return prev;
      const next = [...prev];
      const [shape] = next.splice(idx, 1);
      next.splice(idx - 1, 0, shape);
      return next;
    });
  };

  const handlePdfPagesInsert = (selectedPagesData, x, y) => {
    const baseX = x != null ? x : window.innerWidth / 2 - 200;
    const baseY = y != null ? y : window.innerHeight / 2 - 150;
    selectedPagesData.forEach((page, index) => {
      const id = Date.now() + index;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const maxWidth = 800;
      const maxHeight = 600;
      let { width, height } = page;
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = width * ratio;
        height = height * ratio;
      }
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(page.canvas, 0, 0, width, height);
      const imageUrl = canvas.toDataURL('image/jpeg', 0.8);
      setShapes(prev => [...prev, {
        id,
        type: 'image',
        x: baseX + index * 20,
        y: baseY + index * 20,
        src: imageUrl,
        width,
        height,
        filename: `PDF Page ${page.pageNumber}`,
      }]);
    });
    setPdfModal(null);
  };

  return {
    handlePdfModalClose,
    handleShapeChange,
    handleShapeDuplicate,
    handleShapeDelete,
    handleShapeBringForward,
    handleShapeSendBackward,
    handlePdfPagesInsert,
  };
}
